import {
  faFacebook,
  faGithub,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        backgroundColor: "#06172D",
        position: "relative",
        top: "10vh",
      }}
    >
      <div className="container d-flex justify-content-between">
        <div>
          <p
            style={{
              fontSize: "20px",
            }}
            className="m-0 p-5 text-white"
          >
            {new Date().getFullYear()} All rights reserved || &#169;
            <span className="text-danger font-weight-bold"> Naimul Alam</span>
          </p>
        </div>
        <div>
          <div className="text-center footerlogo text-white m-0 p-5">
            <a
              href="https://www.facebook.com/NaimulAlam01"
              style={{ color: "white" }}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faFacebook}
                size="lg"
                className="mx-2 my-2"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/naimul-alam/"
              style={{ color: "white" }}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faLinkedinIn}
                size="lg"
                className="mx-2 my-2"
              />
            </a>
            <a
              href="https://github.com/NaimulAlam"
              style={{ color: "white" }}
              rel="noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon
                icon={faGithub}
                size="lg"
                className="mx-2 my-2"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
